<template>
  <div
    id="user-actions"
    class="no-shrink">
    <!-- <button @click="emit">open</button> -->
    <span
      id="contact-info"
      class="user-action info"
      :class="{active: activeSection === 'info'}"
      @click="activateSection('info')"/>
    <span
      id="contact-notes"
      class="user-action notes"
      :class="{active: activeSection === 'notes'}"
      @click="activateSection('notes')"/>
    <span
      v-if="hasProperty"
      id="property-details"
      class="user-action house"
      :class="{active: activeSection === 'properties'}"
      @click="activateSection('properties')"/>

    <!-- POPOVERS for action buttons -->
    <b-popover
      target="contact-info"
      triggers="hover"
      placement="left"
      custom-class="basic-popover left-3">
      Contact info
    </b-popover>
    <b-popover
      target="contact-notes"
      triggers="hover"
      placement="left"
      custom-class="basic-popover left-3">
      Contact notes
    </b-popover>
    <b-popover
      target="property-details"
      triggers="hover"
      placement="left"
      custom-class="basic-popover">
      Property details
    </b-popover>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'PanelMenu',
  components: {},
  props: {
    menuActsAsToggle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      notesPropertiesRegex: new RegExp('Received e-mail', 'g'),
    };
  },
  computed: {
    ...mapGetters({
      activeSection: 'contactDetails/activeSection',
      contact: 'contactDetails/contactData',
    }),
    hasProperty() {
      // return this.contact.meta_data.notes.some(note => note.match(this.notesPropertiesRegex));
      return false;
    },
  },
  watch: {
    contact(changedContact) {
      this.notes = changedContact.meta_data.notes;
    },
  },
  methods: {
    ...mapMutations({
      storeActiveSectionSet: 'contactDetails/CTRL_ACTIVE_SECTION_SET',
    }),
    activateSection(section) {
      let newSection = section;

      // if acting as toggle, clicking an active section will close all sections
      if (this.menuActsAsToggle && this.activeSection === section) {
        newSection = '';
      }

      // above section only hides the content if menuActsAsToggle but the column wrapper is still visible
      // This is a hack at the moment and needs to be resolved durring rewrite.
      if (this.activeSection === section) {
        this.$emit('hide');
      }

      this.storeActiveSectionSet(newSection);
    },
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'left',
        animation: false,
        delay: { show: 500, hide: 200 },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#user-actions {
  overflow: hidden;
  background-color: $white;
  width: 50px;
  box-shadow: -1px 0 $greyBorderSecondary;
  z-index: 1000;

  .user-action {
    display: block;
    width: 26px;
    height: 26px;
    background-color: $blackPrimary;
    border-radius: 50%;
    margin: 13px 12px 0 12px;
    position: relative;
    cursor: pointer;

    &::before {
      filter: invert(100%);
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &.info {
      &::before {
        filter: invert(0%);
        background-image: url('~@/assets/img/SB-Icons/member.svg');
        background-size: 10px;
        background-position: center;
      }
    }

    &.notes {
      &::before {
        background-image: url('~@/assets/img/SB-Icons/notes.svg');
        background-size: 10px;
        background-position: center;
      }
    }

    &.house {
      &::before {
        background-image: url('~@/assets/img/icons/house.svg');
        background-size: 50%;
      }
    }

    &:hover {
      box-shadow: 0px 0px 0 5px $actionButtonHoverGray;
    }

    &.active {
      background-color: $bluePrimary;
      box-shadow: 0px 0px 0 5px $actionButtonHoverBlue;
    }
  }
}
</style>
